export default __webpack_public_path__ + "static/photo-climbing-collage-3d3959ebf03c942c6be4828fd3699b29.jpg";